import { PlusOutlined } from '@ant-design/icons';
import { DndContext, DragOverlay } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useRelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { useBasicDndDragger } from '@framework/ui/core/dnd/hooks/useBasicDndDragger.ts';
import { Alert } from 'antd';
import { useState } from 'react';
import { v4 } from 'uuid';
import { type ITableRow } from '../ITableRow.ts';
import { SortableTableRowItem } from './SortableTableRowItem.tsx';
import { TableRowsWidgetEditDrawer } from './TableRowsWidgetEditDrawer.tsx';
import { TableRowView } from './TableRowView.tsx';

export interface ITableRowsWidgetListProps {
  name: string;
}

/**
 * Componente con D'n'D per la configurazione della lista delle opzioni di widget checkbox/radio/select
 */
export function TableRowsWidgetList(props: ITableRowsWidgetListProps) {
  const { name } = props;

  const editor = useRelationEditor<ITableRow>(name);
  const [index, setIndex] = useState<number | null>(null);

  const { sensors, handleDragStart, handleDragEnd, itemIds, active } =
    useBasicDndDragger(editor);

  return (
    <div>
      {editor.items.length < 1 && (
        <Alert type="warning" showIcon message="Aggiungere almeno una riga" />
      )}

      <FormItem name={name} label={null}>
        <DndContext
          sensors={sensors}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
          modifiers={[restrictToVerticalAxis]}
        >
          <SortableContext
            items={itemIds}
            strategy={verticalListSortingStrategy}
          >
            {editor.items.map((item, index) => (
              <SortableTableRowItem
                item={item}
                uid={item.__uid!}
                key={item.__uid}
                active={active}
                onEdit={e => {
                  editor.handle.open(item);
                }}
                onRemove={e => {
                  editor.remove(item);
                }}
                onAdd={e => {
                  setIndex(index + 1);
                  editor.handle.open({
                    id: v4(),
                    customRow: false,
                    label: [{ type: 'text', text: '' }],
                    code: '',
                  });
                }}
              />
            ))}
            <DragOverlay>
              {active && <TableRowView item={active} />}
            </DragOverlay>
          </SortableContext>
        </DndContext>

        {/* Pulsanti da aggiunta */}

        <TableRowsWidgetEditDrawer
          editor={editor}
          index={index}
          setIndex={setIndex}
          buttonProps={{
            type: 'dashed',
            size: 'large',
            icon: <PlusOutlined aria-hidden="true" />,
            block: true,
            children: 'Aggiungi Riga',
          }}
        />
      </FormItem>
    </div>
  );
}
